import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/layout'

Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}


const routes = [{
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true
  },
  {
    path: '/h5',
    component: () => import('@/views/h5/index'),
    hidden: true
  },
  {
    path: '/impower',
    component: () => import('@/views/h5/impower'),
    hidden: true
  },
  {
    path: '/vzan',
    component: () => import('@/views/h5/vzan'),
    hidden: true
  }, {
    path: '/privacy',
    component: () => import('@/views/h5/privacy'),
    hidden: true
  }, {
    path: '/seniorCircle',
    component: () => import('@/views/officialWebsite/seniorCircle'),
    hidden: true
  },
  {
    path: '/',
    component: Layout,
    children: [{
      path: '/',
      name: 'Home',
      component: () => import('@/views/home/index'),
      meta: {
        title: 'Home',
        icon: 'icon-dashboard'
      }
    }]
  },
  {
    path: '/center',
    component: Layout,
    children: [{
      path: '/classroom',
      name: 'classroom',
      // redirect: 'singerlist',
      component: () => import('@/views/center/classroom'),
      meta: {
        title: '教室管理'
      },
    }, {
      path: '/addClassroom',
      name: 'addClassroom',
      // redirect: 'singerlist',
      component: () => import('@/views/center/addClassroom'),
      meta: {
        title: '添加教室'
      },
    }, {
      path: '/editClassroom',
      name: 'editClassroom',
      // redirect: 'singerlist',
      component: () => import('@/views/center/editClassroom'),
      meta: {
        title: '修改教室'
      },
    }, {
      path: '/classandgrade',
      name: 'classandgrade',
      // redirect: 'singerlist',
      component: () => import('@/views/center/classandgrade'),
      meta: {
        title: '班级管理'
      },
    }, {
      path: '/addClassandgrade',
      name: 'addClassandgrade',
      // redirect: 'singerlist',
      component: () => import('@/views/center/addClassandgrade'),
      meta: {
        title: '添加班级'
      },
    }, {
      path: '/editClassandgrade',
      name: 'editClassandgrade',
      // redirect: 'singerlist',
      component: () => import('@/views/center/editClassandgrade'),
      meta: {
        title: '编辑班级'
      },
    }, {
      path: '/arrangement',
      name: 'arrangement',
      // redirect: 'singerlist',
      component: () => import('@/views/center/arrangement'),
      meta: {
        title: '排课管理'
      },
    }, {
      path: '/addArrangement',
      name: 'addArrangement',
      // redirect: 'singerlist',
      component: () => import('@/views/center/addArrangement'),
      meta: {
        title: '添加排课'
      },
    }, {
      path: '/editArrangement',
      name: 'editArrangement',
      // redirect: 'singerlist',
      component: () => import('@/views/center/editArrangement'),
      meta: {
        title: '修改排课'
      },
    }, {
      path: '/student',
      name: 'student',
      // redirect: 'singerlist',
      component: () => import('@/views/center/student'),
      meta: {
        title: '学员管理',
        keepAlive: true
      },
    }, {
      path: '/addStudent',
      name: 'addStudent',
      // redirect: 'singerlist',
      component: () => import('@/views/center/addStudent'),
      meta: {
        title: '添加学员'
      },
    }, {
      path: '/editStudent',
      name: 'editStudent',
      // redirect: 'singerlist',
      component: () => import('@/views/center/editStudent'),
      meta: {
        title: '修改学员'
      },
    }, {
      path: '/teacher',
      name: 'teacher',
      // redirect: 'singerlist',
      component: () => import('@/views/center/teacher'),
      meta: {
        title: '老师管理'
      },
    }, {
      path: '/addTeacher',
      name: 'addTeacher',
      // redirect: 'singerlist',
      component: () => import('@/views/center/addTeacher'),
      meta: {
        title: '添加老师'
      },
    }, {
      path: '/editTeacher',
      name: 'editTeacher',
      // redirect: 'singerlist',
      component: () => import('@/views/center/editTeacher'),
      meta: {
        title: '编辑老师'
      },
    }, {
      path: '/addStudentCourse',
      name: 'addStudentCourse',
      // redirect: 'singerlist',
      component: () => import('@/views/center/addStudentCourse'),
      meta: {
        title: '添加学生课程'
      },
    }, {
      path: '/lookStudentCourse',
      name: 'lookStudentCourse',
      // redirect: 'singerlist',
      component: () => import('@/views/center/lookStudentCourse'),
      meta: {
        title: '查看学生课程'
      },
    }, {
      path: '/editStudentCourse',
      name: 'editStudentCourse',
      // redirect: 'singerlist',
      component: () => import('@/views/center/editStudentCourse'),
      meta: {
        title: '编辑学生课程'
      },
    }, {
      path: '/audit',
      name: 'audit',
      // redirect: 'singerlist',
      component: () => import('@/views/center/audit'),
      meta: {
        title: '审核管理'
      },
    }, {
      path: '/editAudit',
      name: 'editAudit',
      // redirect: 'singerlist',
      component: () => import('@/views/center/editAudit'),
      meta: {
        title: '编辑审核'
      },
    }, {
      path: '/counselor',
      name: 'counselor',
      // redirect: 'singerlist',
      component: () => import('@/views/center/counselor'),
      meta: {
        title: '顾问管理'
      },
    }, {
      path: '/addCounselor',
      name: 'addCounselor',
      // redirect: 'singerlist',
      component: () => import('@/views/center/addCounselor'),
      meta: {
        title: '添加顾问管理'
      },
    }, {
      path: '/editCounselor',
      name: 'editCounselor',
      // redirect: 'singerlist',
      component: () => import('@/views/center/editCounselor'),
      meta: {
        title: '编辑顾问管理'
      },
    }, {
      path: '/lookStudentGrade',
      name: 'lookStudentGrade',
      // redirect: 'singerlist',
      component: () => import('@/views/center/lookStudentGrade'),
      meta: {
        title: '查看学生班级'
      },
    }, {
      path: '/addStudentGrade',
      name: 'addStudentGrade',
      // redirect: 'singerlist',
      component: () => import('@/views/center/addStudentGrade'),
      meta: {
        title: '添加学生班级'
      },
    }, {
      path: '/editStudentGrade',
      name: 'editStudentGrade',
      // redirect: 'singerlist',
      component: () => import('@/views/center/editStudentGrade'),
      meta: {
        title: '编辑学生班级'
      },
    }, {
      path: '/lookCourseScheduling',
      name: 'lookCourseScheduling',
      // redirect: 'singerlist',
      component: () => import('@/views/center/lookCourseScheduling'),
      meta: {
        title: '编辑学生班级'
      },
    }, {
      path: '/addCourseScheduling',
      name: 'addCourseScheduling',
      // redirect: 'singerlist',
      component: () => import('@/views/center/addCourseScheduling'),
      meta: {
        title: '添加排课记录'
      },
    }, {
      path: '/editCourseScheduling',
      name: 'editCourseScheduling',
      // redirect: 'singerlist',
      component: () => import('@/views/center/editCourseScheduling'),
      meta: {
        title: '编辑排课记录'
      },
    }, {
      path: '/lookStudentCourseRecord',
      name: 'lookStudentCourseRecord',
      // redirect: 'singerlist',
      component: () => import('@/views/center/lookStudentCourseRecord'),
      meta: {
        title: '查看学员排课记录'
      },
    }, {
      path: '/role',
      name: 'role',
      // redirect: 'singerlist',
      component: () => import('@/views/center/role'),
      meta: {
        title: '角色管理'
      },
    }, {
      path: '/addRole',
      name: 'addRole',
      // redirect: 'singerlist',
      component: () => import('@/views/center/addRole'),
      meta: {
        title: '添加角色'
      },
    }, {
      path: '/editRole',
      name: 'editRole',
      // redirect: 'singerlist',
      component: () => import('@/views/center/editRole'),
      meta: {
        title: '编辑角色'
      },
    }, {
      path: '/account',
      name: 'account',
      // redirect: 'singerlist',
      component: () => import('@/views/center/account'),
      meta: {
        title: '账号管理'
      },
    }, {
      path: '/editAccount',
      name: 'editAccount',
      // redirect: 'singerlist',
      component: () => import('@/views/center/editAccount'),
      meta: {
        title: '账号编辑'
      },
    }, {
      path: '/lookJurisdiction',
      name: 'lookJurisdiction',
      // redirect: 'singerlist',
      component: () => import('@/views/center/lookJurisdiction'),
      meta: {
        title: '角色权限'
      },
    }, {
      path: '/activity',
      name: 'activity',
      // redirect: 'singerlist',
      component: () => import('@/views/center/activity'),
      meta: {
        title: '活动管理'
      },
    }, {
      path: '/addActivity',
      name: 'addActivity',
      // redirect: 'singerlist',
      component: () => import('@/views/center/addActivity'),
      meta: {
        title: '添加活动'
      },
    }, {
      path: '/editActivity',
      name: 'editActivity',
      // redirect: 'singerlist',
      component: () => import('@/views/center/editActivity'),
      meta: {
        title: '编辑活动'
      },
    }, {
      path: '/mallGoods',
      name: 'mallGoods',
      // redirect: 'singerlist',
      component: () => import('@/views/center/mallGoods'),
      meta: {
        title: '商城商品'
      },
    }, {
      path: '/mallOrder',
      name: 'mallOrder',
      // redirect: 'singerlist',
      component: () => import('@/views/center/mallOrder'),
      meta: {
        title: '商城订单'
      },
    }, {
      path: '/addCommodity',
      name: 'addCommodity',
      // redirect: 'singerlist',
      component: () => import('@/views/center/addCommodity'),
      meta: {
        title: '添加商品'
      },
    }, {
      path: '/editCommodity',
      name: 'editCommodity',
      // redirect: 'singerlist',
      component: () => import('@/views/center/editCommodity'),
      meta: {
        title: '编辑商品'
      },
    }, {
      path: '/order',
      name: 'order',
      // redirect: 'singerlist',
      component: () => import('@/views/center/order'),
      meta: {
        title: '订单管理'
      },
    }, {
      path: '/deposit',
      name: 'deposit',
      // redirect: 'singerlist',
      component: () => import('@/views/center/deposit'),
      meta: {
        title: '提现管理'
      },
    }, {
      path: '/conversion',
      name: 'conversion',
      // redirect: 'singerlist',
      component: () => import('@/views/center/conversion'),
      meta: {
        title: '兑换管理'
      },
    }, {
      path: '/campus',
      name: 'campus',
      // redirect: 'singerlist',
      component: () => import('@/views/center/campus'),
      meta: {
        title: '校区管理'
      },
    }, {
      path: '/addCampus',
      name: 'addCampus',
      // redirect: 'singerlist',
      component: () => import('@/views/center/addCampus'),
      meta: {
        title: '添加校区'
      },
    }, {
      path: '/editCampus',
      name: 'editCampus',
      // redirect: 'singerlist',
      component: () => import('@/views/center/editCampus'),
      meta: {
        title: '编辑校区'
      },
    }, {
      path: '/catalogue',
      name: 'catalogue',
      // redirect: 'singerlist',
      component: () => import('@/views/center/catalogue'),
      meta: {
        title: '课程目录管理'
      },
    }, {
      path: '/addCatalogue',
      name: 'addCatalogue',
      // redirect: 'singerlist',
      component: () => import('@/views/center/addCatalogue'),
      meta: {
        title: '添加课程目录'
      },
    }, {
      path: '/editCatalogue',
      name: 'editCatalogue',
      // redirect: 'singerlist',
      component: () => import('@/views/center/editCatalogue'),
      meta: {
        title: '编辑课程目录'
      },
    }, {
      path: '/course',
      name: 'course',
      // redirect: 'singerlist',
      component: () => import('@/views/center/course'),
      meta: {
        title: '课程管理'
      },
    }, {
      path: '/addCourse',
      name: 'addCourse',
      // redirect: 'singerlist',
      component: () => import('@/views/center/addCourse'),
      meta: {
        title: '添加课程'
      },
    }, {
      path: '/editCourse',
      name: 'editCourse',
      // redirect: 'singerlist',
      component: () => import('@/views/center/editCourse'),
      meta: {
        title: '编辑课程'
      },
    }, {
      path: '/campusCourse',
      name: 'campusCourse',
      // redirect: 'singerlist',
      component: () => import('@/views/center/campusCourse'),
      meta: {
        title: '校区课程'
      },
    }, {
      path: '/campusCourseBinding',
      name: 'campusCourseBinding',
      // redirect: 'singerlist',
      component: () => import('@/views/center/campusCourseBinding'),
      meta: {
        title: '校区课程绑定'
      },
    }, {
      path: '/tuition',
      name: 'tuition',
      // redirect: 'singerlist',
      component: () => import('@/views/center/tuition'),
      meta: {
        title: '学费管理'
      },
    }, {
      path: '/meal',
      name: 'meal',
      // redirect: 'singerlist',
      component: () => import('@/views/center/meal'),
      meta: {
        title: '套餐管理'
      },
    }, {
      path: '/addMeal',
      name: 'addMeal',
      // redirect: 'singerlist',
      component: () => import('@/views/center/addMeal'),
      meta: {
        title: '新增套餐'
      },
    }, {
      path: '/bindMeal',
      name: 'bindMeal',
      // redirect: 'singerlist',
      component: () => import('@/views/center/bindMeal'),
      meta: {
        title: '套餐绑定'
      },
    }, {
      path: '/editMeal',
      name: 'editMeal',
      // redirect: 'singerlist',
      component: () => import('@/views/center/editMeal'),
      meta: {
        title: '套餐编辑'
      },
    }, {
      path: '/lookMeal',
      name: 'lookMeal',
      // redirect: 'singerlist',
      component: () => import('@/views/center/lookMeal'),
      meta: {
        title: '查看套餐'
      },
    }, {
      path: '/lelingUser',
      name: 'lelingUser',
      // redirect: 'singerlist',
      component: () => import('@/views/center/lelingUser'),
      meta: {
        title: '用户管理'
      },
    }, {
      path: '/byOneseifCourse',
      name: 'byOneseifCourse',
      // redirect: 'singerlist',
      component: () => import('@/views/center/byOneseifCourse'),
      meta: {
        title: '学员添加课程'
      },
    }, {
      path: '/verify',
      name: 'verify',
      // redirect: 'singerlist',
      component: () => import('@/views/center/verify'),
      meta: {
        title: '核销管理'
      },
    }, {
      path: '/listActivity',
      name: 'listActivity',
      // redirect: 'singerlist',
      component: () => import('@/views/center/listActivity'),
      meta: {
        title: '活动管理'
      },
    }, {
      path: '/listActivityDetails',
      name: 'listActivityDetails',
      // redirect: 'singerlist',
      component: () => import('@/views/center/listActivityDetails'),
      meta: {
        title: '活动详情'
      },
    }, {
      path: '/arrange',
      name: 'arrange',
      // redirect: 'singerlist',
      component: () => import('@/views/center/arrange'),
      meta: {
        title: '排课记录'
      },
    }, {
      path: '/editArrange',
      name: 'editArrange',
      // redirect: 'singerlist',
      component: () => import('@/views/center/editArrange'),
      meta: {
        title: '排课编辑'
      },
    }, {
      path: '/arrangeDetails',
      name: 'arrangeDetails',
      // redirect: 'singerlist',
      component: () => import('@/views/center/arrangeDetails'),
      meta: {
        title: '学员详情'
      },
    }, {
      path: '/gradeStudent',
      name: 'gradeStudent',
      // redirect: 'singerlist',
      component: () => import('@/views/center/gradeStudent'),
      meta: {
        title: '班级学员'
      },
    }, {
      path: '/addGradeStudent',
      name: 'addGradeStudent',
      // redirect: 'singerlist',
      component: () => import('@/views/center/addGradeStudent'),
      meta: {
        title: '添加班级学员'
      },
    }, {
      path: '/campusTeacher',
      name: 'campusTeacher',
      // redirect: 'singerlist',
      component: () => import('@/views/center/campusTeacher'),
      meta: {
        title: '顾问老师'
      },
    }, {
      path: '/give',
      name: 'give',
      // redirect: 'singerlist',
      component: () => import('@/views/center/give'),
      meta: {
        title: '赠送管理'
      },
    }, {
      path: '/statistics',
      name: 'statistics',
      // redirect: 'singerlist',
      component: () => import('@/views/center/statistics'),
      meta: {
        title: '统计管理'
      },
    }, {
      path: '/operationLog',
      name: 'operationLog',
      // redirect: 'singerlist',
      component: () => import('@/views/center/operationLog'),
      meta: {
        title: '操作日志'
      },
    }, {
      path: '/videoCourse',
      name: 'videoCourse',
      // redirect: 'singerlist',
      component: () => import('@/views/center/videoCourse'),
      meta: {
        title: '视频课程'
      },
    }, {
      path: '/videoCourseAdd',
      name: 'videoCourseAdd',
      // redirect: 'singerlist',
      component: () => import('@/views/center/videoCourseAdd'),
      meta: {
        title: '添加视频课程'
      },
    }, {
      path: '/videoCourseEdit',
      name: 'videoCourseEdit',
      // redirect: 'singerlist',
      component: () => import('@/views/center/videoCourseEdit'),
      meta: {
        title: '编辑视频课程'
      },
    }, {
      path: '/videoCourseStudent',
      name: 'videoCourseStudent',
      // redirect: 'singerlist',
      component: () => import('@/views/center/videoCourseStudent'),
      meta: {
        title: '网课学员详情'
      },
    }, {
      path: '/videoCourseCatalogue',
      name: 'videoCourseCatalogue',
      // redirect: 'singerlist',
      component: () => import('@/views/center/videoCourseCatalogue'),
      meta: {
        title: '视频课程目录'
      },
    }, {
      path: '/videoCourseCatalogueAdd',
      name: 'videoCourseCatalogueAdd',
      // redirect: 'singerlist',
      component: () => import('@/views/center/videoCourseCatalogueAdd'),
      meta: {
        title: '添加视频课程目录'
      },
    }, {
      path: '/videoCourseCatalogueEdit',
      name: 'videoCourseCatalogueEdit',
      // redirect: 'singerlist',
      component: () => import('@/views/center/videoCourseCatalogueEdit'),
      meta: {
        title: '编辑视频课程目录'
      },
    }, {
      path: '/videoCatalogueStudent',
      name: 'videoCatalogueStudent',
      // redirect: 'singerlist',
      component: () => import('@/views/center/videoCatalogueStudent'),
      meta: {
        title: '视频课程目录学员详情'
      },
    }, {
      path: '/mealTerm',
      name: 'mealTerm',
      // redirect: 'singerlist',
      component: () => import('@/views/center/mealTerm'),
      meta: {
        title: '学期制套餐管理'
      },
    }, {
      path: '/addMealTerm',
      name: 'addMealTerm',
      // redirect: 'singerlist',
      component: () => import('@/views/center/addMealTerm'),
      meta: {
        title: '学期制套餐添加'
      },
    }, {
      path: '/editMealTerm',
      name: 'editMealTerm',
      // redirect: 'singerlist',
      component: () => import('@/views/center/editMealTerm'),
      meta: {
        title: '学期制套餐编辑'
      },
    }, {
      path: '/classandgradeTerm',
      name: 'classandgradeTerm',
      // redirect: 'singerlist',
      component: () => import('@/views/center/classandgradeTerm'),
      meta: {
        title: '学期制班级管理'
      },
    }, {
      path: '/addClassandGradeTerm',
      name: 'addClassandGradeTerm',
      // redirect: 'singerlist',
      component: () => import('@/views/center/addClassandGradeTerm'),
      meta: {
        title: '学期制班级添加'
      },
    }, {
      path: '/addArrangementTerm',
      name: 'addArrangementTerm',
      // redirect: 'singerlist',
      component: () => import('@/views/center/addArrangementTerm'),
      meta: {
        title: '学期制添加排课'
      },
    }, {
      path: '/arrangementTerm',
      name: 'arrangementTerm',
      // redirect: 'singerlist',
      component: () => import('@/views/center/arrangementTerm'),
      meta: {
        title: '学期制班级排课'
      },
    }, {
      path: '/lookStudentGradeTerm',
      name: 'lookStudentGradeTerm',
      // redirect: 'singerlist',
      component: () => import('@/views/center/lookStudentGradeTerm'),
      meta: {
        title: '学期制学员班级'
      },
    }, {
      path: '/lookStudentCourseRecordTrem',
      name: 'lookStudentCourseRecordTrem',
      // redirect: 'singerlist',
      component: () => import('@/views/center/lookStudentCourseRecordTrem'),
      meta: {
        title: '学期制排课记录'
      },
    }, {
      path: '/editClassandGradeTern',
      name: 'editClassandGradeTern',
      // redirect: 'singerlist',
      component: () => import('@/views/center/editClassandGradeTern'),
      meta: {
        title: '学期制班级编辑'
      },
    }, {
      path: '/gradeStudentTerm',
      name: 'gradeStudentTerm',
      // redirect: 'singerlist',
      component: () => import('@/views/center/gradeStudentTerm'),
      meta: {
        title: '学期制班级学员'
      },
    }, {
      path: '/addGradeStudentTerm',
      name: 'addGradeStudentTerm',
      // redirect: 'singerlist',
      component: () => import('@/views/center/addGradeStudentTerm'),
      meta: {
        title: '学期制班级学员添加'
      },
    }, {
      path: '/studentTerm',
      name: 'studentTerm',
      // redirect: 'singerlist',
      component: () => import('@/views/center/studentTerm'),
      meta: {
        title: '学期制学员管理'
      },
    }, {
      path: '/editStudentTerm',
      name: 'editStudentTerm',
      // redirect: 'singerlist',
      component: () => import('@/views/center/editStudentTerm'),
      meta: {
        title: '学期制学员编辑'
      },
    }, {
      path: '/dataMonitor',
      name: 'dataMonitor',
      // redirect: 'singerlist',
      component: () => import('@/views/statistics/dataMonitor'),
      meta: {
        title: '看广告数据统计'
      },
    }, {
      path: '/userDataStatistics',
      name: 'userDataStatistics',
      // redirect: 'singerlist',
      component: () => import('@/views/statistics/userDataStatistics'),
      meta: {
        title: '用户数据明细'
      },
    }, {
      path: '/match',
      name: 'match',
      // redirect: 'singerlist',
      component: () => import('@/views/center/match'),
      meta: {
        title: '比赛管理'
      },
    }, {
      path: '/ecpmData',
      name: 'ecpmData',
      // redirect: 'singerlist',
      component: () => import('@/views/center/ecpmData'),
      meta: {
        title: 'ecpm管理'
      },
    }, {
      path: '/matchData',
      name: 'matchData',
      // redirect: 'singerlist',
      component: () => import('@/views/center/matchData'),
      meta: {
        title: '比赛数据统计'
      },
    }, {
      path: '/addMatch',
      name: 'addMatch',
      // redirect: 'singerlist',
      component: () => import('@/views/center/addMatch'),
      meta: {
        title: '添加比赛'
      },
    }, {
      path: '/addPlayer',
      name: 'addPlayer',
      // redirect: 'singerlist',
      component: () => import('@/views/center/addPlayer'),
      meta: {
        title: '添加选手'
      },
    }, {
      path: '/editPlayer',
      name: 'editPlayer',
      // redirect: 'singerlist',
      component: () => import('@/views/center/editPlayer'),
      meta: {
        title: '编辑选手'
      },
    }, {
      path: '/editMatch',
      name: 'editMatch',
      // redirect: 'singerlist',
      component: () => import('@/views/center/editMatch'),
      meta: {
        title: '编辑比赛'
      },
    }, {
      path: '/operationLogTerm',
      name: 'operationLogTerm',
      // redirect: 'singerlist',
      component: () => import('@/views/center/operationLogTerm'),
      meta: {
        title: '操作日志'
      },
    }, {
      path: '/matchDetails',
      name: 'matchDetails',
      // redirect: 'singerlist',
      component: () => import('@/views/center/matchDetails'),
      meta: {
        title: '比赛详情'
      },
    }, {
      path: '/banner',
      name: 'banner',
      // redirect: 'singerlist',
      component: () => import('@/views/center/banner'),
      meta: {
        title: '栏目管理'
      },
    }, {
      path: '/addbanner',
      name: 'addbanner',
      // redirect: 'singerlist',
      component: () => import('@/views/center/addbanner'),
      meta: {
        title: '添加栏目'
      },
    }, {
      path: '/editbanner',
      name: 'editbanner',
      // redirect: 'singerlist',
      component: () => import('@/views/center/editbanner'),
      meta: {
        title: '编辑栏目'
      },
    }, {
      path: '/advertising',
      name: 'advertising',
      // redirect: 'singerlist',
      component: () => import('@/views/center/advertising'),
      meta: {
        title: '广告管理'
      },
    }, {
      path: '/addAdvertising',
      name: 'addAdvertising',
      // redirect: 'singerlist',
      component: () => import('@/views/center/addAdvertising'),
      meta: {
        title: '广告添加'
      },
    }, {
      path: '/editAdvertising',
      name: 'editAdvertising',
      // redirect: 'singerlist',
      component: () => import('@/views/center/editAdvertising'),
      meta: {
        title: '广告编辑'
      },
    }, {
      path: '/works',
      name: 'works',
      // redirect: 'singerlist',
      component: () => import('@/views/center/works'),
      meta: {
        title: '作品管理'
      },
    }, {
      path: '/commentPage',
      name: 'commentPage',
      // redirect: 'singerlist',
      component: () => import('@/views/center/commentPage'),
      meta: {
        title: '评论管理'
      },
    }, {
      path: '/tour',
      name: 'tour',
      // redirect: 'singerlist',
      component: () => import('@/views/center/tour'),
      meta: {
        title: '跟团管理'
      },
    }, {
      path: '/addTour',
      name: 'addTour',
      // redirect: 'singerlist',
      component: () => import('@/views/center/addTour'),
      meta: {
        title: '跟团添加'
      },
    }, {
      path: '/editTour',
      name: 'editTour',
      // redirect: 'singerlist',
      component: () => import('@/views/center/editTour'),
      meta: {
        title: '跟团编辑'
      },
    }, {
      path: '/tourCrew',
      name: 'tourCrew',
      // redirect: 'singerlist',
      component: () => import('@/views/center/tourCrew'),
      meta: {
        title: '跟团人员'
      },
    }, {
      path: '/addPhoto',
      name: 'addPhoto',
      // redirect: 'singerlist',
      component: () => import('@/views/center/addPhoto'),
      meta: {
        title: '添加图文'
      },
    }, {
      path: '/addVideo',
      name: 'addVideo',
      // redirect: 'singerlist',
      component: () => import('@/views/center/addVideo'),
      meta: {
        title: '添加视频'
      },
    }, {
      path: '/addNotes',
      name: 'addNotes',
      // redirect: 'singerlist',
      component: () => import('@/views/center/addNotes'),
      meta: {
        title: '添加游记'
      },
    }, {
      path: '/testPage',
      name: 'testPage',
      // redirect: 'singerlist',
      component: () => import('@/views/center/testPage'),
      meta: {
        title: '测试页面'
      },
    }, {
      path: '/courseV2',
      name: 'courseV2',
      // redirect: 'singerlist',
      component: () => import('@/views/newPage/courseV2'),
      meta: {
        title: '课程分类'
      },
    }, {
      path: '/addCourseV2',
      name: 'addCourseV2',
      // redirect: 'singerlist',
      component: () => import('@/views/newPage/addCourseV2'),
      meta: {
        title: '课程新建'
      },
    }, {
      path: '/courseDetail',
      name: 'courseDetail',
      // redirect: 'singerlist',
      component: () => import('@/views/newPage/courseDetail'),
      meta: {
        title: '课程详情'
      },
    }, {
      path: '/column',
      name: 'column',
      // redirect: 'singerlist',
      component: () => import('@/views/newPage/column'),
      meta: {
        title: '课程专栏'
      },
    }, {
      path: '/big_column',
      name: 'big_column',
      // redirect: 'singerlist',
      component: () => import('@/views/newPage/big_column'),
      meta: {
        title: '大专栏'
      },
    }, {
      path: '/addColumn',
      name: 'addColumn',
      // redirect: 'singerlist',
      component: () => import('@/views/newPage/addColumn'),
      meta: {
        title: '添加专栏'
      },
    }, {
      path: '/addBigColumn',
      name: 'addBigColumn',
      // redirect: 'singerlist',
      component: () => import('@/views/newPage/addBigColumn'),
      meta: {
        title: '添加大专栏'
      },
    }, {
      path: '/bigColumnDetail',
      name: 'bigColumnDetail',
      // redirect: 'singerlist',
      component: () => import('@/views/newPage/bigColumnDetail'),
      meta: {
        title: '大专栏详情'
      },
    }, {
      path: '/columnDetail',
      name: 'columnDetail',
      // redirect: 'singerlist',
      component: () => import('@/views/newPage/columnDetail'),
      meta: {
        title: '专栏详情'
      },
    }, {
      path: '/tag',
      name: 'tag',
      // redirect: 'singerlist',
      component: () => import('@/views/newPage/tag'),
      meta: {
        title: '标签分类'
      },
    }, {
      path: '/addTag',
      name: 'addTag',
      // redirect: 'singerlist',
      component: () => import('@/views/newPage/addTag'),
      meta: {
        title: '添加标签组'
      },
    }, {
      path: '/tagDetail',
      name: 'tagDetail',
      // redirect: 'singerlist',
      component: () => import('@/views/newPage/tagDetail'),
      meta: {
        title: '编辑标签组'
      },
    }, {
      path: '/tagNext',
      name: 'tagNext',
      // redirect: 'singerlist',
      component: () => import('@/views/newPage/tagNext'),
      meta: {
        title: '用户标签'
      },
    }, {
      path: '/addTagNext',
      name: 'addTagNext',
      // redirect: 'singerlist',
      component: () => import('@/views/newPage/addTagNext'),
      meta: {
        title: '添加用户标签'
      },
    }, {
      path: '/tagNextDetail',
      name: 'tagNextDetail',
      // redirect: 'singerlist',
      component: () => import('@/views/newPage/tagNextDetail'),
      meta: {
        title: '标签详情'
      },
    }, {
      path: '/broadcast',
      name: 'broadcast',
      // redirect: 'singerlist',
      component: () => import('@/views/newPage/broadcast'),
      meta: {
        title: '直播管理'
      },
    }, {
      path: '/addLive',
      name: 'addLive',
      // redirect: 'singerlist',
      component: () => import('@/views/newPage/addLive'),
      meta: {
        title: '添加直播'
      },
    }, {
      path: '/addBjyLive',
      name: 'addBjyLive',
      // redirect: 'singerlist',
      component: () => import('@/views/newPage/addBjyLive'),
      meta: {
        title: '添加百家云直播'
      },
    }, {
      path: '/barrage',
      name: 'barrage',
      // redirect: 'singerlist',
      component: () => import('@/views/newPage/barrage'),
      meta: {
        title: '添加弹幕'
      },
    }, {
      path: '/store',
      name: 'store',
      // redirect: 'singerlist',
      component: () => import('@/views/store/store'),
      meta: {
        title: '门店管理'
      },
    }, {
      path: '/storeDetail',
      name: 'storeDetail',
      // redirect: 'singerlist',
      component: () => import('@/views/store/storeDetail'),
      meta: {
        title: '门店详情'
      },
    }, {
      path: '/addStore',
      name: 'addStore',
      // redirect: 'singerlist',
      component: () => import('@/views/store/addStore'),
      meta: {
        title: '添加门店'
      },
    }, {
      path: '/editStore',
      name: 'editStore',
      // redirect: 'singerlist',
      component: () => import('@/views/store/editStore'),
      meta: {
        title: '编辑门店'
      },
    }, {
      path: '/storeLive',
      name: 'storeLive',
      // redirect: 'singerlist',
      component: () => import('@/views/store/storeLive'),
      meta: {
        title: '直播管理'
      },
    }, {
      path: '/newLive',
      name: 'newLive',
      // redirect: 'singerlist',
      component: () => import('@/views/store/newLive'),
      meta: {
        title: '新增直播'
      },
    }, {
      path: '/newGoods',
      name: 'newGoods',
      // redirect: 'singerlist',
      component: () => import('@/views/store/newGoods'),
      meta: {
        title: '新增商品'
      },
    }, {
      path: '/editGoods',
      name: 'editGoods',
      // redirect: 'singerlist',
      component: () => import('@/views/store/editGoods'),
      meta: {
        title: '编辑商品'
      },
    }, {
      path: '/storeGoods',
      name: 'storeGoods',
      // redirect: 'singerlist',
      component: () => import('@/views/store/storeGoods'),
      meta: {
        title: '商品列表'
      },
    }, {
      path: '/storeOrder',
      name: 'storeOrder',
      // redirect: 'singerlist',
      component: () => import('@/views/store/storeOrder'),
      meta: {
        title: '订单管理'
      },
    }, {
      path: '/storeCoupon',
      name: 'storeCoupon',
      // redirect: 'singerlist',
      component: () => import('@/views/store/storeCoupon'),
      meta: {
        title: '优惠券'
      },
    }, {
      path: '/addCoupon',
      name: 'addCoupon',
      // redirect: 'singerlist',
      component: () => import('@/views/store/addCoupon'),
      meta: {
        title: '新增优惠券'
      },
    }, {
      path: '/editCoupon',
      name: 'editCoupon',
      // redirect: 'singerlist',
      component: () => import('@/views/store/editCoupon'),
      meta: {
        title: '编辑优惠券'
      },
    }, {
      path: '/storeWholesale',
      name: 'storeWholesale',
      // redirect: 'singerlist',
      component: () => import('@/views/store/storeWholesale'),
      meta: {
        title: '门店批发管理'
      },
    }, {
      path: '/addWholesale',
      name: 'addWholesale',
      // redirect: 'singerlist',
      component: () => import('@/views/store/addWholesale'),
      meta: {
        title: '门店批发添加'
      },
    }, {
      path: '/editWholesale',
      name: 'editWholesale',
      // redirect: 'singerlist',
      component: () => import('@/views/store/editWholesale'),
      meta: {
        title: '门店批发编辑'
      },
    }, {
      path: '/storeWholesaleOrder',
      name: 'storeWholesaleOrder',
      // redirect: 'singerlist',
      component: () => import('@/views/store/storeWholesaleOrder'),
      meta: {
        title: '门店批发订单'
      },
    }, {
      path: '/storeTeam',
      name: 'storeTeam',
      // redirect: 'singerlist',
      component: () => import('@/views/store/storeTeam'),
      meta: {
        title: '团队列表'
      },
    }, {
      path: '/teamReviewList',
      name: 'teamReviewList',
      // redirect: 'singerlist',
      component: () => import('@/views/store/teamReviewList'),
      meta: {
        title: '审核列表'
      },
    }, {
      path: '/proportionList',
      name: 'proportionList',
      // redirect: 'singerlist',
      component: () => import('@/views/store/proportionList'),
      meta: {
        title: '分销比例列表'
      },
    }, {
      path: '/editProportion',
      name: 'editProportion',
      // redirect: 'singerlist',
      component: () => import('@/views/store/editProportion'),
      meta: {
        title: '编辑分销比例'
      },
    }, {
      path: '/storeRetail',
      name: 'storeRetail',
      // redirect: 'singerlist',
      component: () => import('@/views/store/retail/storeRetail'),
      meta: {
        title: '门店零售管理'
      },
    }, {
      path: '/addRetail',
      name: 'addRetail',
      // redirect: 'singerlist',
      component: () => import('@/views/store/retail/addRetail'),
      meta: {
        title: '门店零售添加商品'
      },
    }, {
      path: '/editRetail',
      name: 'editRetail',
      // redirect: 'singerlist',
      component: () => import('@/views/store/retail/editRetail'),
      meta: {
        title: '门店零售编辑商品'
      },
    }, {
      path: '/storeRetailOrder',
      name: 'storeRetailOrder',
      // redirect: 'singerlist',
      component: () => import('@/views/store/retail/storeRetailOrder'),
      meta: {
        title: '门店零售订单管理'
      },
    }, {
      path: '/retailColumn',
      name: 'retailColumn',
      // redirect: 'singerlist',
      component: () => import('@/views/store/retail/retailColumn'),
      meta: {
        title: '门店零售栏目管理'
      },
    }, {
      path: '/addRetailColumn',
      name: 'addRetailColumn',
      // redirect: 'singerlist',
      component: () => import('@/views/store/retail/addRetailColumn'),
      meta: {
        title: '添加门店零售栏目'
      },
    }, {
      path: '/editRetailColumn',
      name: 'editRetailColumn',
      // redirect: 'singerlist',
      component: () => import('@/views/store/retail/editRetailColumn'),
      meta: {
        title: '编辑门店零售栏目'
      },
    }, {
      path: '/expressDelivery',
      name: 'expressDelivery',
      // redirect: 'singerlist',
      component: () => import('@/views/store/retail/expressDelivery'),
      meta: {
        title: '快递公司列表'
      },
    }, {
      path: '/DeliveryFeeTemplateRuleCreate',
      name: 'DeliveryFeeTemplateRuleCreate',
      // redirect: 'singerlist',
      component: () => import('@/views/store/template/DeliveryFeeTemplateRuleCreate'),
      meta: {
        title: '运费模板规则添加'
      },
    }, {
      path: '/storeFreightTemplate',
      name: 'storeFreightTemplate',
      // redirect: 'singerlist',
      component: () => import('@/views/store/template/storeFreightTemplate'),
      meta: {
        title: '运费模板列表'
      },
    }, {
      path: '/addStoreFreightTemplate',
      name: 'addStoreFreightTemplate',
      // redirect: 'singerlist',
      component: () => import('@/views/store/template/addStoreFreightTemplate'),
      meta: {
        title: '添加运费模板'
      },
    }, {
      path: '/editStoreFreightTemplate',
      name: 'editStoreFreightTemplate',
      // redirect: 'singerlist',
      component: () => import('@/views/store/template/editStoreFreightTemplate'),
      meta: {
        title: '编辑运费模板'
      },
    }, {
      path: '/deliveryFeeTemplateRule',
      name: 'deliveryFeeTemplateRule',
      // redirect: 'singerlist',
      component: () => import('@/views/store/template/deliveryFeeTemplateRule'),
      meta: {
        title: '运费模板规则列表'
      },
    }, {
      path: '/DeliveryFeeTemplateRuleEdit',
      name: 'DeliveryFeeTemplateRuleEdit',
      // redirect: 'singerlist',
      component: () => import('@/views/store/template/DeliveryFeeTemplateRuleEdit'),
      meta: {
        title: '运费模板规则编辑'
      },
    }, {
      path: '/shortVideo',
      name: 'shortVideo',
      // redirect: 'singerlist',
      component: () => import('@/views/video/shortVideo'),
      meta: {
        title: '短视频管理'
      },
    }, {
      path: '/shortComment',
      name: 'shortComment',
      // redirect: 'singerlist',
      component: () => import('@/views/video/shortComment'),
      meta: {
        title: '短视频评论列表'
      },
    }, {
      path: '/videoCollectionAdd',
      name: 'videoCollectionAdd',
      // redirect: 'singerlist',
      component: () => import('@/views/video/videoCollectionAdd'),
      meta: {
        title: '添加短视频合集'
      },
    }, {
      path: '/videoCollectionEdit',
      name: 'videoCollectionEdit',
      // redirect: 'singerlist',
      component: () => import('@/views/video/videoCollectionEdit'),
      meta: {
        title: '编辑短视频合集'
      },
    }, {
      path: '/compilationVideo',
      name: 'compilationVideo',
      // redirect: 'singerlist',
      component: () => import('@/views/video/compilationVideo'),
      meta: {
        title: '合集短视频列表'
      },
    }, {
      path: '/compilationVideoAdd',
      name: 'compilationVideoAdd',
      // redirect: 'singerlist',
      component: () => import('@/views/video/compilationVideoAdd'),
      meta: {
        title: '添加合集短视频'
      },
    }, {
      path: '/compilationVideoEdit',
      name: 'compilationVideoEdit',
      // redirect: 'singerlist',
      component: () => import('@/views/video/compilationVideoEdit'),
      meta: {
        title: '编辑合集短视频'
      },
    }, {
      path: '/shortDrama',
      name: 'shortDrama',
      // redirect: 'singerlist',
      component: () => import('@/views/shortPlay/shortDrama'),
      meta: {
        title: '短剧管理'
      },
    }, {
      path: '/shortPlayCollectionAdd',
      name: 'shortPlayCollectionAdd',
      // redirect: 'singerlist',
      component: () => import('@/views/shortPlay/shortPlayCollectionAdd'),
      meta: {
        title: '添加短剧合集'
      },
    }, {
      path: '/shortPlayCollectionEdit',
      name: 'shortPlayCollectionEdit',
      // redirect: 'singerlist',
      component: () => import('@/views/shortPlay/shortPlayCollectionEdit'),
      meta: {
        title: '编辑短剧合集'
      },
    }, {
      path: '/compilationshortPlay',
      name: 'compilationshortPlay',
      // redirect: 'singerlist',
      component: () => import('@/views/shortPlay/compilationshortPlay'),
      meta: {
        title: '合集短剧列表'
      },
    }, {
      path: '/compilationShortPlayAdd',
      name: 'compilationShortPlayAdd',
      // redirect: 'singerlist',
      component: () => import('@/views/shortPlay/compilationShortPlayAdd'),
      meta: {
        title: '添加合集短剧'
      },
    }, {
      path: '/compilationShortPlayEdit',
      name: 'compilationShortPlayEdit',
      // redirect: 'singerlist',
      component: () => import('@/views/shortPlay/compilationShortPlayEdit'),
      meta: {
        title: '编辑合集短剧'
      },
    }, {
      path: '/study',
      name: 'study',
      // redirect: 'singerlist',
      component: () => import('@/views/study/study'),
      meta: {
        title: '学习管理'
      },
    }, {
      path: '/studyCollection',
      name: 'studyCollection',
      // redirect: 'singerlist',
      component: () => import('@/views/study/studyCollection'),
      meta: {
        title: '学习合集管理'
      },
    }, {
      path: '/studyCollectionAdd',
      name: 'studyCollectionAdd',
      // redirect: 'singerlist',
      component: () => import('@/views/study/studyCollectionAdd'),
      meta: {
        title: '学习合集添加'
      },
    }, {
      path: '/studyCollectionEdit',
      name: 'studyCollectionEdit',
      // redirect: 'singerlist',
      component: () => import('@/views/study/studyCollectionEdit'),
      meta: {
        title: '学习合集编辑'
      },
    }, {
      path: '/studyCollectionData',
      name: 'studyCollectionData',
      // redirect: 'singerlist',
      component: () => import('@/views/study/studyCollectionData'),
      meta: {
        title: '合集学习资料管理'
      },
    }, {
      path: '/studyCollectionDataAdd',
      name: 'studyCollectionDataAdd',
      // redirect: 'singerlist',
      component: () => import('@/views/study/studyCollectionDataAdd'),
      meta: {
        title: '添加合集学习资料'
      },
    }, {
      path: '/studyCollectionDataEdit',
      name: 'studyCollectionDataEdit',
      // redirect: 'singerlist',
      component: () => import('@/views/study/studyCollectionDataEdit'),
      meta: {
        title: '编辑合集学习资料'
      },
    }, {
      path: '/channel_agent',
      name: 'channel_agent',
      // redirect: 'singerlist',
      component: () => import('@/views/channel/channel_agent'),
      meta: {
        title: '服务商管理'
      },
    }, {
      path: '/agent_team',
      name: 'agent_team',
      // redirect: 'singerlist',
      component: () => import('@/views/channel/agent_team'),
      meta: {
        title: '服务商团队用户'
      },
    }, {
      path: '/channel_partner',
      name: 'channel_partner',
      // redirect: 'singerlist',
      component: () => import('@/views/channel/channel_partner'),
      meta: {
        title: '合伙人管理'
      },
    }, {
      path: '/partner_team',
      name: 'partner_team',
      // redirect: 'singerlist',
      component: () => import('@/views/channel/partner_team'),
      meta: {
        title: '合伙人团队服务商'
      },
    }, {
      path: '/videoDataMonitor',
      name: 'videoDataMonitor',
      // redirect: 'singerlist',
      component: () => import('@/views/statistics/videoDataMonitor'),
      meta: {
        title: '短视频数据统计'
      },
    }, {
      path: '/dramaDataMonitor',
      name: 'dramaDataMonitor',
      // redirect: 'singerlist',
      component: () => import('@/views/statistics/dramaDataMonitor'),
      meta: {
        title: '短剧数据统计'
      },
    }, {
      path: '/adUserVideoStatistics',
      name: 'adUserVideoStatistics',
      // redirect: 'singerlist',
      component: () => import('@/views/statistics/adUserVideoStatistics'),
      meta: {
        title: '短视频用户数据统计'
      },
    }, {
      path: '/adUserDramaStatistics',
      name: 'adUserDramaStatistics',
      // redirect: 'singerlist',
      component: () => import('@/views/statistics/adUserDramaStatistics'),
      meta: {
        title: '短剧用户数据统计'
      },
    }, {
      path: '/adUserVideoStatistics',
      name: 'adUserVideoStatistics',
      // redirect: 'singerlist',
      component: () => import('@/views/statistics/adUserVideoStatistics'),
      meta: {
        title: '短视频用户数据统计'
      },
    }, {
      path: '/studyDataMonitor',
      name: 'studyDataMonitor',
      // redirect: 'singerlist',
      component: () => import('@/views/statistics/studyDataMonitor'),
      meta: {
        title: '学习数据统计'
      },
    }, {
      path: '/adUserStudyStatistics',
      name: 'adUserStudyStatistics',
      // redirect: 'singerlist',
      component: () => import('@/views/statistics/adUserStudyStatistics'),
      meta: {
        title: '学习用户数据统计'
      },
    }, {
      path: '/userStudyDataStatistics',
      name: 'userStudyDataStatistics',
      // redirect: 'singerlist',
      component: () => import('@/views/statistics/userStudyDataStatistics'),
      meta: {
        title: '学习用户数据明细'
      },
    }, {
      path: '/signDataMonitor',
      name: 'signDataMonitor',
      // redirect: 'singerlist',
      component: () => import('@/views/statistics/signDataMonitor'),
      meta: {
        title: '签到数据统计'
      },
    }, {
      path: '/adUserSignStatistics',
      name: 'adUserSignStatistics',
      // redirect: 'singerlist',
      component: () => import('@/views/statistics/adUserSignStatistics'),
      meta: {
        title: '签到用户数据统计'
      },
    }, {
      path: '/userSignDataStatistics',
      name: 'userSignDataStatistics',
      // redirect: 'singerlist',
      component: () => import('@/views/statistics/userSignDataStatistics'),
      meta: {
        title: '签到用户数据明细'
      },
    }, {
      path: '/adUserWatchVideoStatistics',
      name: 'adUserWatchVideoStatistics',
      // redirect: 'singerlist',
      component: () => import('@/views/statistics/adUserWatchVideoStatistics'),
      meta: {
        title: '精选用户数据统计'
      },
    }, {
      path: '/watchVideoDataMonitor',
      name: 'watchVideoDataMonitor',
      // redirect: 'singerlist',
      component: () => import('@/views/statistics/watchVideoDataMonitor'),
      meta: {
        title: '精选数据统计'
      },
    }, {
      path: '/userWatchVideoDataStatistics',
      name: 'userWatchVideoDataStatistics',
      // redirect: 'singerlist',
      component: () => import('@/views/statistics/userWatchVideoDataStatistics'),
      meta: {
        title: '精选用户数据统计'
      },
    }, {
      path: '/adUserStatistics',
      name: 'adUserStatistics',
      // redirect: 'singerlist',
      component: () => import('@/views/statistics/adUserStatistics'),
      meta: {
        title: '看广告用户数据统计'
      },
    }, {
      path: '/userVideoDataStatistics',
      name: 'userVideoDataStatistics',
      // redirect: 'singerlist',
      component: () => import('@/views/statistics/userVideoDataStatistics'),
      meta: {
        title: '短视频用户数据明细'
      },
    }, {
      path: '/userDramaDataStatistics',
      name: 'userDramaDataStatistics',
      // redirect: 'singerlist',
      component: () => import('@/views/statistics/userDramaDataStatistics'),
      meta: {
        title: '短剧用户数据明细'
      },
    }]
  },
]

const router = new VueRouter({
  routes,
  // mode:"history"
})
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}
export default router